import { z } from 'zod'

export const postSettingsSchema = z.object({
  slug: z
    .string()
    .min(1, 'Slug is required')
    .max(200, 'Slug is too long')
    .trim()
    .regex(
      /^[a-zA-Z0-9-]+$/,
      'Slug can only contain lowercase letters, numbers, and hyphens',
    ),
  publishedAt: z.coerce.date().optional().nullable(),
  featured: z.boolean().default(false),
  visibility: z.enum(['public', 'members', 'paid']).default('public'),
  excerpt: z.string().max(2000, 'Excerpt is too long').optional(),
  type: z.enum(['post', 'page']).default('post'),
  showTitleAndFeatureImage: z.boolean().default(true),
})

export const postMetadataSchema = z.object({
  metaTitle: z.string().max(300, 'Meta title is too long').optional(),
  metaDescription: z
    .string()
    .max(500, 'Meta description is too long')
    .optional(),
  ogTitle: z.string().max(300, 'Title is too long').optional(),
  ogDescription: z.string().max(500, 'Description is too long').optional(),
  ogImage: z
    .string()
    .url('Invalid URL format')
    .optional()
    .or(z.literal(''))
    .nullable(),
  twitterTitle: z.string().max(300, 'Title is too long').optional(),
  twitterDescription: z
    .string()
    .max(500, 'Description is too long')
    .optional(),
  twitterImage: z
    .string()
    .url('Invalid URL format')
    .optional()
    .or(z.literal(''))
    .nullable(),
})

export const createPostSchema = z
  .object({
    title: z.string().min(1, 'Title is required'),
    type: z.enum(['post', 'page']).default('post'),
    featureImage: z.string().url().optional().or(z.literal('')).nullable(),
    featureImageAlt: z.string().optional().nullable(),
    featureImageUnsplashCreditUrl: z.string().url().optional().nullable(),
    json: z.any().optional(),
    html: z.string().optional(),
    status: z.enum(['draft', 'published', 'scheduled']).default('draft'),
    tagIds: z.array(z.string()).optional(),
  })
  .merge(postSettingsSchema.partial())

export const updatePostSchema = z
  .object({
    title: z.string().optional().nullable(),
    featureImage: z.string().url().optional().or(z.literal('')).nullable(),
    featureImageAlt: z.string().optional().nullable(),
    featureImageUnsplashCreditUrl: z.string().url().optional().nullable(),
    json: z.any().optional().nullable(),
    html: z.string().optional().nullable(),
    status: z.enum(['draft', 'published', 'scheduled']).default('draft'),
    tagIds: z.array(z.string()).optional(),
  })
  .merge(postSettingsSchema.partial())
